import React from 'react';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/cartSlice';
import { getLegalCopy } from '../utils/legalTranslations';
import LegalDocument from './LegalDocument';

const PrivacyStatement = () => {
  const selectedLang = useSelector(selectLanguage) || { code: 'en' };
  const copy = getLegalCopy(selectedLang.code || 'en');

  return (
    <LegalDocument
      heading={copy.privacy.heading}
      subtitle={copy.privacy.subtitle}
      sections={copy.privacy.sections}
      companyLabels={copy.company}
    />
  );
};

export default PrivacyStatement;
